import React from 'react'

interface IconWaitProps {
    color?: string
    size?: number
}

export const IconWait: React.FC<IconWaitProps> = ({ color = '#848E9C', size = 24 }) => {
    return (
        <svg
            fill='none'
            height={size}
            viewBox='0 0 10 10'
            width={size}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.91699 8.33398H7.50033V6.95898C7.50033 6.41732 7.29199 5.87565 6.87533 5.50065L6.41699 5.00065L6.87533 4.54232C7.29199 4.12565 7.50033 3.62565 7.50033 3.04232V1.66732H7.91699C8.16699 1.66732 8.33366 1.50065 8.33366 1.25065C8.33366 1.00065 8.16699 0.833984 7.91699 0.833984H2.08366C1.83366 0.833984 1.66699 1.00065 1.66699 1.25065C1.66699 1.50065 1.83366 1.66732 2.08366 1.66732H2.50033V3.04232C2.50033 3.58398 2.70866 4.12565 3.12533 4.50065L3.58366 5.00065L3.12533 5.45898C2.70866 5.87565 2.50033 6.37565 2.50033 6.95898V8.33398H2.08366C1.83366 8.33398 1.66699 8.50065 1.66699 8.75065C1.66699 9.00065 1.83366 9.16732 2.08366 9.16732H7.91699C8.16699 9.16732 8.33366 9.00065 8.33366 8.75065C8.33366 8.50065 8.16699 8.33398 7.91699 8.33398ZM3.33366 6.95898C3.33366 6.62565 3.45866 6.29232 3.70866 6.08398L4.45866 5.33398C4.62533 5.16732 4.62533 4.91732 4.45866 4.75065L3.70866 3.95898C3.45866 3.70898 3.33366 3.37565 3.33366 3.04232V1.66732H6.66699V3.04232C6.66699 3.37565 6.54199 3.70898 6.29199 3.91732L5.54199 4.66732C5.37533 4.83398 5.37533 5.08398 5.54199 5.25065L6.29199 6.00065C6.54199 6.25065 6.66699 6.54232 6.66699 6.87565V8.33398H3.33366V6.95898Z'
                fill={color}
            />
        </svg>
    )
}
